import tokeys from "tokeys";

export default tokeys([
  "GET_ORGANIZATION_DETAIL",
  "GET_ORGANIZATION_LIST",
  "JOIN_ORGANIZATION",
  "SEARCH_ORGANIZATION",
]);
